import { CoverageWithMeta } from '../Coverage.type';

export const getSelectedCoverages = (
  coverages: CoverageWithMeta[],
): CoverageWithMeta[] => coverages.filter(({ fake, coverage }) => !fake && coverage.selected);

export const getCurrentCoverages = (
  coverages: CoverageWithMeta[],
): CoverageWithMeta[] => coverages.filter(({ fake, coverage }) => !fake && coverage);
